import React from "react";
import { ProjectSelector as BaseProjectSelector } from "./ProjectSelector";
import { useActivitiesContext } from "../contexts/ActivitiesContext";
import { HourType } from "./Badges";

interface Project {
  id: string;
  activityId: number;
  name: string;
  activity: string;
  client: string;
  project: string;
  hourType: HourType;
  reference: string;
}

interface SmartProjectSelectorProps {
  value: string;
  onChange: (projectId: string) => void;
  disabled?: boolean;
  error?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
}

export const SmartProjectSelector: React.FC<SmartProjectSelectorProps> = (
  props
) => {
  const { activities, loading } = useActivitiesContext();

  // Transform activities data to match Project interface and sort alphabetically
  const projects: Project[] = activities
    .filter((activity) => activity.project && activity.project.client) // Filter out activities without project data
    .map((activity) => ({
      id: activity.id.toString(),
      activityId: activity.id,
      name: activity.name,
      activity: activity.name,
      client: activity.project!.client.name,
      project: activity.project!.name,
      hourType: activity.hour_type as HourType,
      reference: activity.project!.reference,
    }))
    .sort((a, b) => {
      // Sort by client first, then by project name
      const clientCompare = a.client.localeCompare(b.client);
      if (clientCompare !== 0) return clientCompare;
      return a.project.localeCompare(b.project);
    });

  if (loading) {
    return (
      <BaseProjectSelector
        {...props}
        projects={[]}
        disabled={true}
        placeholder="Loading projects..."
      />
    );
  }

  return <BaseProjectSelector {...props} projects={projects} />;
};
